<template>
  <div class="stepContent">
    <!-- <el-row>
      <el-col>
        <member-info ref="member-info" :data-in="memberInfoData" :options="memberInfoOptions"></member-info>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="18">
        <hr>
      </el-col>
    </el-row> -->
    <el-row>
      <el-col :span="9">
        <workflowInfo :dataIn="workflowInfoData"></workflowInfo>
      </el-col>
      <el-col :span="12">
        <usebalance-editor :isReadOnly="dataIn.isCompleted" :isAdEnrollment="true" :displayEnrollmentCount="true" :dataIn="usebalanceEditorData" @valueChange="onUseBalanceEditorValueChange"></usebalance-editor>
      </el-col>
    </el-row>
    <div v-if="!dataIn.isSupplement && dataIn.courseType === GLOBAL.courseType.university && dataIn.modelData">
      <el-row>
        <el-col :span="18">
          <hr>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <span class="cs-introducers-label">推荐人：</span> 
          <div class="margin-left-20px cs-introducers-container">
            <el-select v-if="!dataIn.isCompleted" v-model="dataIn.modelData.introducerId" size="medium" placeholder="请选择推荐人">
              <el-option v-for="item in introducers" :key="item.Id" :label="item.Name" :value="item.Id">
              </el-option>
            </el-select>
            <span v-else>
              {{getIntroducerName()}}
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-row>
      <el-col :span="18">
        <hr>
      </el-col>
    </el-row>
    <el-row v-if="paymentMode == 0">
      <el-col>
        <paymentListView :dataList="accountModel.AccountPayments" :options="{enableEdit:false,enableRemove:!dataIn.isCompleted}" @item-remove="onAccountPaymentListItemRemove"></paymentListView>
      </el-col>
    </el-row>
    <el-row  v-if="!dataIn.isSupplement">
      <el-col>&nbsp;</el-col>
    </el-row>
    <el-row v-if="!dataIn.isSupplement">
       <el-select
          v-if="!dataIn.isCompleted"
          v-model="paymentMode"
          size="medium"
          placeholder="请选择收费方式"
          @change="onPaymentModeChange"
        >
          <el-option
            v-for="item in paymentModes"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
        <span v-else>{{getPaymentModeText()}}</span>
    </el-row>
    <el-row>
      <el-col>&nbsp;</el-col>
    </el-row>
    <el-row v-if="paymentMode == 1">
      <autonomousPaymentSelector :excepts="[GLOBAL.enumPaymentType.emt, GLOBAL.enumPaymentType.creditCard]" :readonly="dataIn.isCompleted" v-model="paymentType" @change="onPaymentTypeChange" />
    </el-row>
    <el-row v-if="dataIn.isCompleted && paymentMode == 1 && !!paymentType && !!dataIn.modelData.qrCodeImage">
      <img :src="dataIn.modelData.qrCodeImage" />
    </el-row>
    <el-row v-if="paymentMode == 0 || dataIn.isSupplement">
      <el-col>
        <el-button v-if="!dataIn.isCompleted" :loading="isSavePayment" size="medium" :disabled="submitBtnDisable" :type="submitBtnClass" @click="showAddPaymentEditor">添加支付</el-button>
      </el-col>
    </el-row>
    <el-dialog :center="true" :close-on-click-modal="false" width="600px" :visible.sync="paymentEditorVisible" top="3vh">
      <paymentEditor :options="paymentEditorOptions" :data="paymentEditorData" @closeDialog="onAddPaymentEditorClose" @callback="onAddPaymentEditorCallback"></paymentEditor>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.stepContent {
  padding: 20px;
}

.el-col {
  span {
    height: 40px;
    line-height: 40px;
    padding-left: 10px;

    &.cs-introducers-label{
      padding-left: 0;
    }
  }
}

.cs-introducers-container{
  display: inline-block;
}
</style>

<script> 
import {
  createAccountModel,
  saveAccount,
  removeAccountPayment,
  saveContinueAccountPayment
} from "../../../service/finance.service.js";
import {
  getAccountByWorkflowId,
} from "../../../service/enrollmentFee.service";
import workflowInfo from "./aefWorkflowInfo";
import usebalanceEditor from "../useBalanceEditor";
import paymentEditor from "../../common/paymentEditor";
import paymentListView from "../../common/paymentListView";
import {convertToFloat, toDecimal} from "../../../config/mUtils.js";

export default {
  props: {
    dataIn: {
      introducers: Array,
      isCompleted: Boolean,
      accountType:Number,
      courseType:Number,
      workflowId:Number,
      memberModel:Object,
      enrollmentCount: Number,
      aeTotalPrice:Number,
      aeDiscountPrice: Number,
      priceSettings:Object,
      discountList:[],
      memberCardModel:{
        hasBuyMemberCard:Boolean,
        memberCardDiscountPrice:Number,
      },
      modelData:{
        enrollmentCount: Number,
        balance:Number,
        bonusPoint:Number,
        cashDecreased:Number,
        comment:String,
        isAutonomousPayment: Boolean,
        paymentType: Number,
        qrCodeImage: String,
        introducerId: Number,
      },
    },
    workMode:String
  },
  data() {
    return {
      isSavePayment: false,
      submitBtnClass: "primary",
      submitBtnDisable: false,
      paymentEditorVisible: false,
      discounts: [],
      workflowInfoData:{
        memberCardModel:{
          hasBuyMemberCard:false,
          memberCardDiscountPrice:0,
        },
        memberCardPrice:0,
        enrollmentCount: 0,
        aeTotalPrice: 0,
        aeDiscountPrice:0,
        balance:0,
        bonusPointAmount:0,
        cashDecreased:0,
        accountAmount:0,
        totalPayment:0,
        comments: '',
        discountList:[]
      },
      usebalanceEditorData:{
        memberModel:{},
        enrollmentCountUsed: 0,
        accountAmount: 0,
        accountAmountWithTax: 0,
        priceSettings:{},
        modelData: {},
        modelUsedData: {},
        courseType:1
      },
      paymentEditorOptions: {
        showTitle: true,
        allowPaidCount: 0,
        showAccountAmountLeft: true
      },
      paymentEditorData:{},
      paymentList:[],
      accountpaymentListOptions:{},
      accountModel:{
        AccountPayments:[],
      },
      originalModel:{

      },
      paymentMode: 0,
      paymentModes:[{key: 0, value: "前台收费"},{key: 1, value: "学生自主缴费"}],
      paymentType: null,
      introducers: []
    };
  },
  components: {
    workflowInfo,
    usebalanceEditor,
    paymentEditor,
    paymentListView,
    autonomousPaymentSelector: () => import("@/components/payApi/paymentSelector")
  },
  computed: {
    totalPayment: function() {
      let total = 0;
      if (!!this.accountModel){
        this.accountModel.AccountPayments.forEach(element => {
          total += element.Amount;
        });
      }
      return total;
    },
    bonusPointAmount:function(){
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.modelData){
        if (this.bonusPointToMoney_BonusPoint > 0){
            value = parseInt(this.dataIn.modelData.bonusPoint) * this.bonusPointToMoney_Money /  this.bonusPointToMoney_BonusPoint;
        }
      }
      return value;
    },
    //使用总优惠
    balanceTotal:function(){
      let value = 0;
      if (!!this.dataIn && !!this.dataIn.modelData){
        value = convertToFloat(this.dataIn.modelData.balance) + 
          this.bonusPointAmount + convertToFloat(this.dataIn.modelData.cashDecreased);
      }
      return value;
    },
    //扣除优惠后总应付
    accountAmount:function(){
      let value = this.dataIn.aeDiscountPrice;
      if (this.dataIn.memberCardModel.hasBuyMemberCard){
        value += this.dataIn.memberCardModel.memberCardDiscountPrice;
      }
      value -= this.balanceTotal;
      return value;
    }, 
    accountAmountLeft:function(){
      let value = this.accountAmount - this.totalPayment;
      value = toDecimal(value);
      if (value < 0){
        value = 0;
      }
      return value;
    },
    autonomousPaymentTypes() {
      let retValue = this.GLOBAL.enumPaymentType.getOptionsForCheckpay([this.GLOBAL.enumPaymentType.emt, this.GLOBAL.enumPaymentType.creditCard]);
      return retValue;
    }
  },
  created() {
    this.init();
  },
  updated() {},
  methods: {
    init(){
      if (!!this.dataIn && !!this.dataIn.priceSettings && !!this.dataIn.memberCardModel &&
        this.dataIn.memberModel){
        this.bonusPointToMoney_Money = this.dataIn.priceSettings.bonusPointToMoney_Money;
        this.bonusPointToMoney_BonusPoint = this.dataIn.priceSettings.bonusPointToMoney_BonusPoint;
        this.adEnrollmentPrice= this.dataIn.priceSettings.adEnrollmentPrice;
        if (this.dataIn.courseType == 3){
            this.adEnrollmentPrice= this.dataIn.priceSettings.trainingAdEnrollmentPrice;
        }
       
        let modelData = {};
        let modelUsedData ={};
        if (this.dataIn.isSupplement){
          this.originalModel = JSON.parse(JSON.stringify(this.dataIn.modelData));
          modelUsedData = JSON.parse(JSON.stringify(this.dataIn.modelData));
          modelData={
            enrollmentCount: 0,
            balance:0,
            bonusPoint:0,
            cashDecreased:0,
            comment:"",
            isAutonomousPayment: false
          };

        }else{
          modelData = JSON.parse(JSON.stringify(this.dataIn.modelData));
          modelUsedData={
            enrollmentCount: 0,
            balance:0,
            bonusPoint:0,
            cashDecreased:0,
            comment:"",
            isAutonomousPayment: false
          };
        }

        if (this.dataIn.modelData.isAutonomousPayment){
          this.paymentMode = 1;
        }else{
          this.paymentMode = 0;
        }

        if (this.autonomousPaymentTypes.contains(this.dataIn.modelData.paymentType, (item, value) => item.value === value)) {
          this.paymentType = this.dataIn.modelData.paymentType;
        } else {
          this.paymentType = null;
        }
       
        this.usebalanceEditorData = {
          memberModel:this.dataIn.memberModel,
          enrollmentCountUsed: 0,
          accountAmount: this.accountAmount,
          accountAmountWithTax: this.accountAmount,
          priceSettings:this.dataIn.priceSettings,
          modelData: modelData,
          modelUsedData: modelUsedData,
          courseType: this.dataIn.courseType
        };
      
        this.loadAccountModel();
        this.loadWorkflowInfoData();
      }else{
         this.workflowInfoData = {
          memberCardModel:{
            hasBuyMemberCard:false,
            memberCardDiscountPrice:0,
          },
          memberCardPrice:0,
          enrollmentCount: 0,
          aeTotalPrice: 0,
          aeDiscountPrice:0,
          balance:0,
          bonusPointAmount:0,
          cashDecreased:0,
          accountAmount:0,
          totalPayment:0,
          comments: '',
          discountList:[]
        };
      }
    },
    loadWorkflowInfoData(){
      this.workflowInfoData = {
        memberCardModel:this.dataIn.memberCardModel,
        memberCardPrice:this.dataIn.priceSettings.memberCardPrice,
        enrollmentCount: this.dataIn.enrollmentCount,
        aeTotalPrice: this.dataIn.aeTotalPrice,
        aeDiscountPrice: this.dataIn.aeDiscountPrice,
        balance:convertToFloat(this.dataIn.modelData.balance),
        bonusPointAmount:this.bonusPointAmount,
        cashDecreased:convertToFloat(this.dataIn.modelData.cashDecreased),
        accountAmount:this.accountAmount,
        totalPayment:this.totalPayment,
        comments: this.dataIn.modelData.comment,
        discountList: this.dataIn.discountList
      };
    },
    loadAccountModel() { 
      if (!!this.dataIn && !!this.dataIn.memberModel.StudentId && !!this.dataIn.workflowId){
        getAccountByWorkflowId(this.dataIn.memberModel.StudentId, this.dataIn.workflowId).then(result => {
          if (!!result && result.success) {
            this.accountModel = result.data;
            this.showError = false;
            this.errorMessage = "";
          } else {
            this.initAccountModel();
            this.showError = true;
            this.errorMessage = result.message;
          }
          this.loadWorkflowInfoData();
        });
      }else{
        this.initAccountModel();
      }
    },
    async saveAccountModel() {
      this.accountModel.Amount = this.accountAmount;
      this.isSavePayment = true;
      this.submitBtnDisable = true;
      this.$emit("savePaymentStart");

      let result = await saveAccount(this.accountModel);
      if (!!result && result.success) {
        this.loadAccountModel();
        //this.checkCompleteAvailable();
      }

      this.isSavePayment = false;
      this.submitBtnDisable = false;
      this.$emit("savePaymentEnd");
    },
    getAccountAmount(){
      return this.accountAmountLeft;
    },
    checkCompleteAvailable(){
      if (this.dataIn.modelData.isAutonomousPayment){
        return true;
      }

      let isCompleteAvailable = false;
      if (this.accountAmountLeft <= 0){
        isCompleteAvailable = true;
      }
      return isCompleteAvailable;
    },
    async onUseBalanceEditorValueChange(result, isReduce) {
      let balance = 0;
      let bonusPoint = 0;
      let enrollmentCount = 0;
      let cashDecreased = 0;
      if (!!result.balance){
        balance = convertToFloat(result.balance)
      }
      if (!!result.bonusPoint){
        bonusPoint = parseInt(result.bonusPoint)
      }
      if (!!result.enrollmentCount){
        enrollmentCount = parseInt(result.enrollmentCount)
      }
      if (!!result.cashDecreased){
        cashDecreased = convertToFloat(result.cashDecreased)
      }

      if (this.dataIn.isSupplement){
        let comment = this.originalModel.comment;
        if (!!comment){
          comment = comment + " " + result.comment;
        }
        if (isReduce){
          this.$set(this.dataIn.modelData,"balance", this.originalModel.balance - balance);
          this.$set(this.dataIn.modelData,"bonusPoint", this.originalModel.bonusPoint - bonusPoint);
          this.$set(this.dataIn.modelData,"enrollmentCount", this.originalModel.enrollmentCount - enrollmentCount);
          this.$set(this.dataIn.modelData,"cashDecreased", this.originalModel.cashDecreased - cashDecreased);
        }else{
          this.$set(this.dataIn.modelData,"balance", balance + this.originalModel.balance);
          this.$set(this.dataIn.modelData,"bonusPoint", bonusPoint + this.originalModel.bonusPoint);
          this.$set(this.dataIn.modelData,"enrollmentCount", enrollmentCount + this.originalModel.enrollmentCount);
          this.$set(this.dataIn.modelData,"cashDecreased", cashDecreased + this.originalModel.cashDecreased);
        }
      
        this.$set(this.dataIn.modelData,"comment", comment);
      }else{
        this.$set(this.dataIn.modelData,"balance", balance);
        this.$set(this.dataIn.modelData,"bonusPoint", bonusPoint);
        this.$set(this.dataIn.modelData,"enrollmentCount", enrollmentCount);
        this.$set(this.dataIn.modelData,"cashDecreased", cashDecreased);
        this.$set(this.dataIn.modelData,"comment", result.comment);
      }
     
      this.loadWorkflowInfoData();
      this.$emit("save");
    },
    showAddPaymentEditor() {
      this.paymentEditorData = {accountAmountLeft: this.accountAmountLeft};
      this.paymentEditorVisible = true;
    },
    onAddPaymentEditorClose() {
      this.paymentEditorVisible = false;
    },
    onAddPaymentEditorCallback(result) {
      if (result.success){
        this.accountModel.AccountPayments.push(result.data);
        if(!!this.workMode && this.workMode == 'ContinuePayment'){
          result.data.AccountId = this.accountModel.Id; 
          this.accountModel.Amount = this.accountAmount; 
           saveContinueAccountPayment(result.data).then(r=>{
            if(!!r && r.success){
              this.loadAccountModel();
            }
          });
         
        }
        else{ 
          this.saveAccountModel();
        }
      }
    },
    onAccountPaymentListItemRemove(data) { 
 
      if (!!data && !!data.item && !!data.item.Id){
        this.isSavePayment = true;
        this.submitBtnDisable = true;

        removeAccountPayment(data.item.Id, this.workMode).then(result => {
          if (!result) {
            return;
          } 
          if (result.success) {
            this.$message({
              message: "删除支付成功",
              type: "success"
            });
            this.accountModel.AccountPayments.splice(data.index, 1);
            this.saveAccountModel();
          } else {
            this.$message({
              message: "删除支付失败",
              type: "error"
            });
            this.isSavePayment = false;
            this.submitBtnDisable = false;
          }
        });
      }
    },
    initAccountModel() {
      this.accountModel = createAccountModel(this.dataIn.accountType);
      if (!!this.dataIn){
        this.accountModel.WorkflowId = this.dataIn.workflowId;
        this.accountModel.StudentId = this.dataIn.memberModel.StudentId;
      }
      this.accountModel.Amount = this.accountAmount;
    },
    onPaymentModeChange() {
      if (this.paymentMode == 0){
        this.dataIn.modelData.isAutonomousPayment = false;
      }else{
        this.dataIn.modelData.isAutonomousPayment = true;
      }
    },
    onPaymentTypeChange() {
      this.dataIn.modelData.paymentType = this.paymentType;
    },
    getPaymentModeText(){
      let item = this.paymentModes.find(i => i.key == this.paymentMode);
      if (item){
        return item.value;
      }
      return "";
    },
    loadIntroducers() {
      if (this.dataIn && this.dataIn.introducers && this.dataIn.memberModel) {
        let groupNumber = this.dataIn.memberModel.UniversityGroupNumber;
        if (groupNumber) {
          this.introducers = this.dataIn.introducers.filter(i => i.UniversityGroup === groupNumber);
        } else {
          this.introducers = [];
        }
      } else {
        this.introducers = [];
      }
    },
    getIntroducerName(){
      if (this.dataIn && this.dataIn.introducers && this.dataIn.modelData && this.dataIn.modelData.introducerId) {
        let item = this.dataIn.introducers.find(i => i.Id === this.dataIn.modelData.introducerId);
        return item.Name;
      }
      return "";
    }
  },
  watch: {
    dataIn:function(){
      this.init();
    },
    "dataIn.memberModel":function(model){
      if (!!this.usebalanceEditorData){
        this.$set(this.usebalanceEditorData, "memberModel",model);
      }
      this.loadIntroducers();
    },
    "dataIn.introducers": function (newVal) {
      this.loadIntroducers();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addCollectFees/advanceEnrollmentFee/aefWorkflowStep3.vue